// extracted by mini-css-extract-plugin
export var deliveryRow = "_i3-a";
export var fixedHeight = "_i3-4";
export var freightLogo = "_i3-9";
export var fullWidth = "_i3-3";
export var priceColumn = "_i3-5";
export var radioSelected = "_i3-7";
export var radioUnselected = "_i3-6";
export var selectedOption = "_i3-2";
export var selectedOptionContainer = "_i3-1";
export var selection = "_i3-0";
export var tallSkeletonText = "_i3-8";